import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { UpdateStopInfoRequest, UpdateStopInfoResponse } from '../type';
import { updateStopInfoFn } from './update-stop-point-info-fn';
import { apiRoutes } from '@/api/api-routes';

export const useUpdateStopInfo = (
  orderId: string,
  opts?: UseMutationOptions<
    UpdateStopInfoResponse,
    DefaultQueryError,
    UpdateStopInfoRequest
  >
) =>
  useMutation<UpdateStopInfoResponse, DefaultQueryError, UpdateStopInfoRequest>(
    {
      mutationKey: [apiRoutes.order.stopInformation, orderId],
      mutationFn: (body: UpdateStopInfoRequest) =>
        updateStopInfoFn(orderId, body),
      ...opts,
    }
  );
